import { useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';

const useOnNavigate = (onNavigate: () => void) => {
  const history = useHistory();
  const previousPathname = useRef(history.location.pathname);

  useEffect(
    () =>
      history.listen((location) => {
        if (location.pathname === previousPathname.current) {
          return;
        }

        previousPathname.current = location.pathname;
        onNavigate();
      }),
    [history, onNavigate],
  );
};

export default useOnNavigate;
